import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { DateTime } from 'scaleflow/utils/date-time';
export default class PlanningDatePickerComponent extends Component {
  @service('organisation') orgService;

  @action
  defaultDate(initiative) {
    if (this.args.value) return this.args.value;
    const start_date = initiative?.startDate;
    if (!start_date) return null;
    else {
      const date = DateTime.from(start_date);
      return date.isValid() ? date.toDate() : null;
    }
  }

  @action
  onDateChange(e) {
    if (e.length > 0) this.args?.onDateChange?.(e[0]);
  }

  @action
  onReady(_, __, instance) {
    this.datepickerInstance = instance;
    this.args?.onReady?.(instance);
  }
}
